const routes = [
    {
        path: "/daily/course/schedules/calendar",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'studentreport_monthlycourseprogramreport'
        }
    }
];

export default routes;
